import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {Amplify} from 'aws-amplify'
import 'bootstrap-daterangepicker/daterangepicker.css'

import {ApolloProvider} from '@apollo/client'
import {appoloClientConfig} from './utils/helper'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)
console.log('indec laoded')

const config = {
  amplifyConfig: {
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
    region: process.env.REACT_APP_REGION,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
}

Amplify.configure(config.amplifyConfig)

const queryClient = new QueryClient()
const container = document.getElementById('root')

// Check if redirection is needed before rendering the app
const adminDashboardUrl = localStorage.getItem('adminDashboardUrl')?.split('/')[1]
const currentPath = window.location.pathname.split('/')[1]
const subpath = window.location.pathname.split('/')[2]
const hasRedirected = localStorage.getItem('hasRedirected')
console.log('=======', currentPath, adminDashboardUrl)
const exemptedPaths = [
  'contract',
  'customerbill',
  'sms-tpv',
  'enrollmentDocuments',
  'customerdocumentupload',
]
const exemptedSubPaths = ['account-activation', 'new-password']
if (currentPath === '') {
  window.open(`${window.location.origin}/tpvadmin/login`, '_self')
} else if (
  adminDashboardUrl !== currentPath &&
  !hasRedirected &&
  !exemptedPaths.includes(currentPath) &&
  !exemptedSubPaths.includes(subpath)
) {
  localStorage.clear()
  localStorage.setItem('hasRedirected', 'true')
  window.open(`${window.location.origin}/${currentPath}/login`, '_self')
} else {
  localStorage.removeItem('hasRedirected')
  if (container) {
    createRoot(container).render(
      <ApolloProvider client={appoloClientConfig}>
        <QueryClientProvider client={queryClient}>
          <MetronicI18nProvider>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </MetronicI18nProvider>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
      </ApolloProvider>
    )
  }
}
